interface SpinnerProps {
  text?: string;
}

const Spinner = ({ text = 'Chargement...' }: SpinnerProps) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <div className="w-6 h-6 border-2 border-foreground border-t-transparent rounded-full animate-spin mx-auto"></div>
      {text && <p className="text-[13px] text-muted-foreground mt-1">{text}</p>}
    </div>
  );
};

const SpinnerScreen = ({ text = 'Chargement...' }: SpinnerProps) => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <Spinner text={text} />
    </div>
  );
};

export { Spinner, SpinnerScreen };
